"use client";
import { useFeatureHost } from "./use-feature-host";
import type { FeatureNavigation } from "./navigation-context";

export function useFeatureNavigation(): FeatureNavigation {
  return useFeatureHost().navigation;
}
